<div class="modal-header">
    <h6 class="modal-title medium" *ngIf="type == 'SUSPEND'">{{'suspendEmployee' | translate}}</h6>
    <h6 class="modal-title medium" *ngIf="type == 'ACTIVE'">{{'activateEmployee' | translate}}</h6>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="w-100 float-left p-4 modal-body">
    <h6 *ngIf="type == 'SUSPEND'">{{'confirmSuspendEmployee'| translate}}</h6>
    <h6 *ngIf="type == 'ACTIVE'">{{'confirmActivateEmployee' | translate}} </h6>
</div>
<div class="modal-footer">
    <button class="btn btn-secondary float-right" (click)="activeModal.dismiss('Cross click')">{{'cancel' |
        translate}}
    </button>
    <button class="btn btn-primary float-right" (click)="suspendOrActiveEmployee()" [disabled]='showButtonLoading'>
        {{'confirm' | translate}}
        <i *ngIf="showButtonLoading" class="fa fa-spinner fa-spin text-white m-l-smd"></i>
    </button>
</div>


// WEBPACK FOOTER //
// ./src/app/employee/employeeActions/actionSuspend.html